/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// Taken from
// https://github.com/angular/angular/blob/bf8ba89394ffd6d2047261e89d9f41e6ef66be3e/packages/common/src/cookie.ts

/**
 * Get the value of a cookie from the given cookie string
 *
 * @param cookieStr The cookie string (`document.cookie`)
 * @param name The name of the cookie to get
 * @returns The value of the cookie, or `null` if the cookie is absent
 */
export function parseCookieValue(cookieStr: string, name: string): string | null {
  name = encodeURIComponent(name);

  for (const cookie of cookieStr.split(';')) {
    const eqIndex = cookie.indexOf('=');
    const [cookieName, cookieValue]: string[] =
      eqIndex === -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)];

    if (cookieName.trim() === name) {
      return decodeURIComponent(cookieValue);
    }
  }

  return null;
}
